import styled from '@emotion/styled'
import { Theme } from '../../styles/settings/theme'

const PieWrapper = styled.div`
  position: relative;
`

const Wrapper = styled.div`
  height: 5.5rem;
  width: 5.5rem;
  position: absolute;
  top: 0;
  z-index: 1;

  &.circleBase {
    position: relative;
    z-index: 0;
  }
  &:after {
    content: '';
    position: absolute;
    height: 56px;
    width: 56px;
    background-color: white;
    border-radius: 50%;
    top: 16px;
    left: 16px;
    zindex: 2;
  }
  svg {
    height: 100%;
    width: 100%;
    transform: rotate(-90deg);
  }
`
const Value = styled.p`
  font-size: ${(props) => props.theme.fontSizes[2]};
  font-weight: 700;
  color: ${(props) => props.theme.colors.gray};
  position: absolute;
  top: 34%;
  left: 28px;
  z-index: 3;
`
const Pie = ({ value }) => {
  return (
    <PieWrapper>
      <Wrapper className={'circleBase'}>
        <svg viewBox="0 0 48 48">
          <circle
            stroke={Theme.colors.gray3}
            fill={Theme.colors.gray3}
            strokeWidth="6"
            r="16"
            cx="24"
            cy="24"
          />
        </svg>
      </Wrapper>
      <Wrapper>
        <svg viewBox="0 0 48 48">
          <circle
            stroke={Theme.colors.gray}
            fill={Theme.colors.gray3}
            strokeWidth="6"
            r="16"
            cx="24"
            cy="24"
            strokeDasharray={`${value * 100}, 100`}
          />
        </svg>
      </Wrapper>
      <Value>{(value * 100).toFixed() + '%'}</Value>
    </PieWrapper>
  )
}

export default Pie
